export default [
  {
    nome: 'Caixa de entrada',
    icon: 'fal fa-envelope',
    routeGroup: 'vistoria/caixa-entrada',
    permissao: 'VIEW_CAIXA_ENTRADA'
  },
  {
    nome: 'Finalizadas',
    icon: 'fal fa-clipboard-list',
    routeGroup: 'vistoria/caixa-finalizadas',
    permissao: 'VIEW_CAIXA_FINALIZADOS'
  }
]



// WEBPACK FOOTER //
// ./src/libs/constants/painel/vistoria/menu.js